import { inject, Injectable } from '@angular/core';
import { MessagingService } from '../../../cross-team-shared/messaging/messaging.service';
import {
  isLogArgument,
  RollbarService,
} from '../../../cross-team-shared/messaging/rollbar.service';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { AnnotationLoadingService } from './annotation-loading.service';

export const PRE_ANNOTATIONS_SUBMISSION_ID = -1;

@Injectable()
export class SubmissionLoadingService {
  private requestedSubmissionsIds: StrictRecord<number, Promise<void>> = {};
  private annotationLoadingService = inject(AnnotationLoadingService);
  private rollbarService = inject(RollbarService);
  private messagingService = inject(MessagingService);
  private store = inject(TaskWorkspaceStore);

  load(submissionId: number) {
    this.requestedSubmissionsIds[submissionId] ??= this.loadAnnotations(
      submissionId,
    ).catch((error) => this.handleSubmissionLoadError(error));
    return this.requestedSubmissionsIds[submissionId];
  }

  private loadAnnotations(submissionId: number) {
    const submission = this.store
      .state()
      .task.submissions?.find((s) => s.id === submissionId);
    return this.annotationLoadingService.loadPreviousAnnotations(submission);
  }

  private handleSubmissionLoadError(error: unknown) {
    if (isLogArgument(error)) {
      this.rollbarService.error('Failed to load previous submission', error);
    }
    this.messagingService.error(
      'Failed to load previous submission, reload the page to try again.',
    );
  }
}
